import Vue from 'vue';
import 'floating-vue/dist/style.css';

import { VTooltip, options } from 'floating-vue';

options.themes.tooltip.triggers = window.innerWidth > 991 ? ['hover'] : ['click'];
options.themes.tooltip.autoHide = true;

Vue.directive('tooltip', VTooltip);
